import {
    compose,
    filter,
    flatten,
    fromPairs,
    map,
    mapObjIndexed,
    prop,
    propEq,
    props,
    uniq,
} from 'ramda';
import { columnTypes } from "@qdabra/forms-shared/sharePoint";

const { SP_TYPE_DATE_TIME } = columnTypes;

export const listDateFields = compose(
    map(prop('internalName')),
    filter(propEq('type', SP_TYPE_DATE_TIME)),
);

const getItemFieldValues = (fieldNames) => compose(
    filter(Boolean),
    props(fieldNames),
);

export const collectFieldValues = (fieldNames, items) => compose(
    uniq,
    flatten,
    map(getItemFieldValues(fieldNames)),
)(items);

const makeFieldNamesMap = compose(
    fromPairs,
    map(v => [v, true]),
);

const replaceItemFieldValues = (fieldNamesMap, valueMap) => mapObjIndexed(
    (val, key) => fieldNamesMap[key]
        ? valueMap[val] || val
        : val,
);

export const replaceFieldValues = (fieldNames, valueMap, items) => map(
    replaceItemFieldValues(makeFieldNamesMap(fieldNames), valueMap),
    items,
);